import { render, staticRenderFns } from "./attrSort.vue?vue&type=template&id=db09e8ee&scoped=true"
import script from "./attrSort.vue?vue&type=script&lang=js"
export * from "./attrSort.vue?vue&type=script&lang=js"
import style0 from "./attrSort.vue?vue&type=style&index=0&id=db09e8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db09e8ee",
  null
  
)

export default component.exports